import type { InsuranceExpenseCustomItem } from "Forms/Schemas/Budget/Expenses/insuranceExpenseFormSchema";
import { AmountFrequency } from "Infrastructure/ApiZfp/Schema";

export const monthlyDivisors: Partial<Record<AmountFrequency, number>> = {
  [AmountFrequency.monthly]: 1,
  [AmountFrequency.quarterly]: 3,
  [AmountFrequency.half_yearly]: 6,
  [AmountFrequency.yearly]: 12,
};

export const calculateMonthlyTotal = (items: InsuranceExpenseCustomItem[]) =>
  items.reduce((sum, item) => {
    if (item.period === AmountFrequency.one_time) {
      return sum;
    }
    const value = Number.parseFloat(item.amount ?? "0") || 0;
    const divisor = monthlyDivisors[item.period as AmountFrequency] ?? 1;
    return sum + value / divisor;
  }, 0);
